<template>
    <button
            :style="{
                        backgroundImage: 'url(images/commons/btnHome.png)'
                     }"
            class="relative w-10 h-10 mr-2 md:w-10 md:h-10 2xl:w-16 2xl:h-16 bg-center bg-no-repeat bg-contain pointer-events-auto shadow-2xl rounded-full"
            v-show="$route.name === 'catalogue'"
            @click="handleClick()"
    ></button>
</template>

<script>
import router from "../router";

export default {
    name: "BtnSummary",
    methods: {
        handleClick() {
            // $eventbus.$emit('modal:richmedia:hide');
            this.$router.push({name: 'summary'});
        }
    },
    mounted(){
        tippy(this.$el, {
            theme: 'light',
            content: 'Aller à la page d’accueil ',
        });
    }
}
</script>

<style scoped>

</style>
